import { compose, withProps, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { getCharitySelector } from './selectors'
import {
  getCharityUpcomingAuctions,
  getCharityFinishedAuctions
} from '../mycharity/charity/selectors'
import { fetchCharity, fetchCharityAuctions } from './actions'
import withTranslations from '../../core/withTranslations'
import CharityOurAuctions from '../../ui/views/charity-our-auctions'

const translations = withTranslations({
  ourEventsText: 'charity.ourEvents',
  upcomingText: 'common:upcoming',
  finishedText: 'common:finished'
})

const mapStateToProps = (state, props) => {
  const charityId = Number(props.match.params.id)
  const charity = charityId && getCharitySelector(charityId)(state)
  return {
    charityId,
    charity,
    upcomingAuctions: getCharityUpcomingAuctions(charityId)(state),
    finishedAuctions: getCharityFinishedAuctions(charityId)(state)
  }
}
const withCharityAndAuctionsData = connect(mapStateToProps, {
  fetchCharity,
  fetchCharityAuctions
})

const withFetchOnMount = lifecycle({
  componentDidMount() {
    const {
      charityId,
      charity,
      fetchCharity,
      upcomingAuctions,
      finishedAuctions,
      fetchCharityAuctions
    } = this.props
    if (!charity) fetchCharity(charityId)
    if (
      (upcomingAuctions && !upcomingAuctions.length) ||
      (finishedAuctions && !finishedAuctions.length)
    )
      fetchCharityAuctions(this.props.charityId)
  }
})

const withFormattedProps = withProps(props => {
  const { charity } = props
  return {
    charityName: charity && charity.name,
    crumbs: [
      {
        linkText: charity && charity.name,
        linkUrl: charity && `/charities/${charity.id}`
      }
    ]
  }
})

export const CharityOurAuctionsEnhancer = compose(
  translations,
  withCharityAndAuctionsData,
  withFetchOnMount,
  withFormattedProps
)

export default CharityOurAuctionsEnhancer(CharityOurAuctions)



// WEBPACK FOOTER //
// ./src/services/charity/CharityOurAuctions.js